import React, { useEffect, useState } from "react";
import { fetchLatestTweets } from "../services/apiService";
import TweetEmbed from "./TweetEmbed";

const usernames = [
    { user: "Elon Musk", handle: "@elonmusk", avatar: "/images/elon.png", username: "elonmusk" },
    { user: "Watcher.Guru", handle: "@WatcherGuru", avatar: "/images/watcher.png", username: "WatcherGuru" },
];

// Fallback tweets
const dummyTweets = [
    {
        user: "Watcher.Guru",
        handle: "@WatcherGuru",
        avatar: "/images/watcher.png",
        content: "JUST IN: BlackRock’s Bitcoin ETF has officially surpassed $20 billion in AUM. 🚀",
        time: "2h ago",
    },
    {
        user: "WhaleChart",
        handle: "@WhaleChart",
        avatar: "/images/whalechart.png",
        content: "Elon Musk says ‘Crypto will become the primary financial system’ — thoughts?",
        time: "1h ago",
    }
];

const TrendingTweets = () => {
    const [tweets, setTweets] = useState([]);
    const [useFallback, setUseFallback] = useState(false);

    useEffect(() => {
        const loadTweets = async () => {
            const handles = usernames.map(u => u.username);
            const res = await fetchLatestTweets(handles);

            if (res.success) {
                const data = res.data;
                const parsedTweets = usernames
                    .map(u => {
                        const tweetData = data[u.username];
                        if (tweetData && tweetData.tweet && tweetData.tweet.id) {
                            return {
                                ...u,
                                tweetId: tweetData.tweet.id,
                                createdAt: tweetData.tweet.created_at,
                            };
                        }
                        return null;
                    })
                    .filter(Boolean);

                if (parsedTweets.length > 0) {
                    setTweets(parsedTweets);
                } else {
                    setUseFallback(true);
                }
            } else {
                setUseFallback(true);
            }
        };

        loadTweets();
    }, []);

    return (
        <section className="text-white">
            <h2 className="text-2xl font-bold text-blue-400 mb-4">New Posts</h2>
            <div className="space-y-6">
                {useFallback
                    ? dummyTweets.map((tweet, index) => (
                        <div
                            key={index}
                            className="bg-white/5 border border-blue-500 rounded-xl p-4 flex gap-4"
                        >
                            <img
                                src={tweet.avatar}
                                alt={tweet.handle}
                                className="w-10 h-10 rounded-full object-cover border border-white/10"
                                onError={(e) => (e.target.style.display = "none")}
                            />
                            <div className="flex-1">
                                <div className="flex justify-between items-center mb-1">
                                    <div>
                                        <p className="font-semibold text-blue-300">{tweet.user}</p>
                                        <p className="text-sm text-gray-400">{tweet.handle}</p>
                                    </div>
                                    <span className="text-xs text-gray-500">{tweet.time}</span>
                                </div>
                                <p className="text-sm text-gray-200">{tweet.content}</p>
                            </div>
                        </div>
                    ))
                    : tweets.map((tweet, index) => (
                        <div
                            key={index}
                            className="bg-white/5 border border-blue-500 rounded-xl p-4 flex flex-col gap-4"
                        >
                            <div className="flex gap-4 items-center">
                                <img
                                    src={tweet.avatar}
                                    alt={tweet.handle}
                                    className="w-10 h-10 rounded-full object-cover border border-white/10"
                                    onError={(e) => (e.target.style.display = "none")}
                                />
                                <div>
                                    <p className="font-semibold text-blue-300">{tweet.user}</p>
                                    <p className="text-sm text-gray-400">{tweet.handle}</p>
                                </div>
                            </div>
                            <TweetEmbed tweetId={tweet.tweetId} />
                        </div>
                    ))}
            </div>
        </section>
    );
};

export default TrendingTweets;
